import {
  DELETE_INVESTMENT_PROPERTY_SUMMARY,
  GET_INVESTMENT_PROPERTY_SUMMARY,
  GET_INVESTMENT_PROPERTY_SUMMARY_LIST,
  POST_INVESTMENT_PROPERTY_SUMMARY,
  PUT_INVESTMENT_PROPERTY_SUMMARY,
} from "../constants/actionTypes";

const defaultState = {
  investmentPropertySummaryArr:[],
  investmentPropertySummary:{}
};
let data = []

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_PROPERTY_SUMMARY_LIST:
        return {...state,investmentPropertySummaryArr:[...action.payload]};
      case GET_INVESTMENT_PROPERTY_SUMMARY:
        return {...state,investmentPropertySummary:{...action.payload}};
      case POST_INVESTMENT_PROPERTY_SUMMARY:
        return {...state,investmentPropertySummaryArr:[...state?.investmentPropertySummaryArr,action.payload]};
      case PUT_INVESTMENT_PROPERTY_SUMMARY:
        data = [...state?.investmentPropertySummaryArr];
        index = data?.findIndex(
          (setting) => setting?.id_customer === action.payload?.id_customer,
        );
        if (index != -1) data[index] = { ...action?.payload };
        return {...state,investmentPropertySummaryArr: [...data]};
      case DELETE_INVESTMENT_PROPERTY_SUMMARY:
        data = [...state?.investmentPropertySummaryArr];
        const newData = data?.filter(
          (income) => income.id!=action.payload,
        );
        return {...state,investmentPropertySummaryArr: [...newData]};
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
